__turbopack_context__.v({
  "blockHeader": "BlockHeader-module-scss-module__RleMpG__blockHeader",
  "blockHeder": "BlockHeader-module-scss-module__RleMpG__blockHeder",
  "headline": "BlockHeader-module-scss-module__RleMpG__headline",
  "subheadline": "BlockHeader-module-scss-module__RleMpG__subheadline",
});
